<!--  prettier-ignore-->
<template>
  <!-- eslint-disable-next-line vue/no-v-text-v-html-on-component vue/no-v-html -->
  <component :is="`h${level}`" class="text-text-neutral-primary text-lg font-semibold" v-html="text"/>
</template>

<script setup lang="ts">
  defineProps<{
    text: string;
    level: number;
  }>();
</script>
